export const GOOGLE_LOGIN_CLIENT_ID: string =
  process.env.REACT_APP_GOOGLE_LOGIN_CLIENT_ID || "";

export const USER_LOCAL_STORAGE_KEY =
  process.env.REACT_APP_USER_LOCAL_STORAGE_KEY || "USER_INFO";

export const GOSTORE_UTILITY_TOOLS_SERVICE_ENDPOINT =
  process.env.REACT_APP_GOSTORE_UTILITY_TOOLS_SERVICE_ENDPOINT ||
  "http://localhost:3000";
